(function () {
  document.querySelectorAll('.announcement-bar--classic-wrapper').forEach(function (wrapper) {
    var track = wrapper.querySelector('.announcement-bar--classic-track');
    var items = track.querySelectorAll('.announcement-bar--classic-item');
    if (items.length <= 1) return;

    var direction = track.dataset.direction;
    var speed = parseInt(wrapper.dataset.speed, 10) || 4000;
    var isVertical = direction === 'vertical';
    var current = 0;

    var itemSize = 0;

    // Set item sizes so the wrapper clips exactly one item
    function setSize() {
      if (isVertical) {
        itemSize = items[0].offsetHeight;
        wrapper.style.height = itemSize + 'px';
      } else {
        itemSize = wrapper.offsetWidth;
        items.forEach(function (item) { item.style.width = itemSize + 'px'; });
        // also update clone
        track.lastElementChild.style.width = itemSize + 'px';
      }
    }

    // Duplicate first item at the end for seamless loop
    var clone = items[0].cloneNode(true);
    track.appendChild(clone);

    setSize();
    window.addEventListener('resize', setSize);

    function goTo(index, animate) {
      track.style.transition = animate ? 'transform 0.5s ease' : 'none';
      var offset = index * itemSize;
      if (isVertical) {
        track.style.transform = 'translateY(-' + offset + 'px)';
      } else {
        track.style.transform = 'translateX(-' + offset + 'px)';
      }
    }

    setInterval(function () {
      current++;
      goTo(current, true);

      // After reaching the clone of first item, snap silently back to real first
      if (current === items.length) {
        setTimeout(function () {
          goTo(0, false);
          current = 0;
        }, 520);
      }
    }, speed);
  });
})();
